import { getItemLocalStorage, setItemLocalStorage } from '@at/window-utils';
import { Channel } from '@at/sauron-platform-core/lib/types';
import { useState } from 'react';
const SEARCH_FIELDS_STORAGE_KEY_PREFIX = `search.fields`;
const DEFAULT_SEARCH_FIELDS = {
    make: null,
    model: null,
    postcode: null,
    distance: null,
    berth: null,
    style: null,
    bodyType: null,
};
const getExistingSearchFields = (channel = Channel.cars, condition = 'used') => {
    const searchFields = getItemLocalStorage(`${SEARCH_FIELDS_STORAGE_KEY_PREFIX}.${channel}.${condition}`);
    if (searchFields) {
        return JSON.parse(searchFields);
    }
    return Object.assign({}, DEFAULT_SEARCH_FIELDS);
};
const saveSearchFields = (searchFields, channel = Channel.cars, condition = 'used') => {
    setItemLocalStorage(`${SEARCH_FIELDS_STORAGE_KEY_PREFIX}.${channel}.${condition}`, JSON.stringify(searchFields));
};
export const useSearchFields = (channel = Channel.cars, condition = 'used') => {
    const exisitingSearchFields = getExistingSearchFields(channel, condition);
    const [searchFields, setSearchFields] = useState(exisitingSearchFields);
    const updateSearchFields = (searchFields) => {
        setSearchFields(searchFields);
        saveSearchFields(searchFields, channel, condition);
    };
    const updatePostcodeSearchFields = (postcode) => {
        const searchFields = Object.assign(Object.assign({}, getExistingSearchFields(channel, condition)), { postcode });
        updateSearchFields(searchFields);
    };
    const resetSearchFields = () => {
        updateSearchFields(DEFAULT_SEARCH_FIELDS);
    };
    return { searchFields, updateSearchFields, updatePostcodeSearchFields, resetSearchFields };
};
